<template>
  <div>
    <h3 class="mb-4">
      {{ $t('Equipment Management') }}
    </h3>

    <v-card>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            class="ml-auto"
            color="secondary"
            @click="exportEquipmentStatisticsPercent"
          >
            {{ $t('export') }}
          </v-btn>
        </div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('% of equipment in good state') }}
                </th>
                <th class="text-left">
                  {{ $t('Number of labs') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>100%</td>
                <td>
                  {{ equipmentStatisticsPercent['100'].length }}
                </td>
              </tr>
              <tr>
                <td> &#60; 75%</td>
                <td>
                  {{ equipmentStatisticsPercent['75'].length }}
                </td>
              </tr>
              <tr>
                <td> &#60; 50%</td>
                <td>
                  {{ equipmentStatisticsPercent['50'].length }}
                </td>
              </tr>
              <tr>
                <td> &#60; 25%</td>
                <td>
                  {{ equipmentStatisticsPercent['25'].length }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-text>
        <div class="d-flex">
          <v-btn
            class="ml-auto"
            color="secondary"
            @click="exportEquipmentStatisticsCalibration"
          >
            {{ $t('export') }}
          </v-btn>
        </div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('Calibration') }}
                </th>
                <th class="text-left">
                  {{ $t('Percent') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ $t('Performed') }}
                </td>
                <td>
                  {{ (equipmentStatisticsCalibration.performed * 100 / equipmentStatisticsCalibration.all).toFixed(2) }} %
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t('Remaining') }}
                </td>
                <td>
                  {{ (equipmentStatisticsCalibration.remaining * 100 / equipmentStatisticsCalibration.all).toFixed(2) }} %
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t('On-time') }}
                </td>
                <td>
                  {{ (equipmentStatisticsCalibration.onTime * 100 / equipmentStatisticsCalibration.all).toFixed(2) }} %
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t('Off-time') }}
                </td>
                <td>
                  {{ (equipmentStatisticsCalibration.offTime * 100 / equipmentStatisticsCalibration.all).toFixed(2) }} %
                </td>
              </tr>

            <!--          <tr>-->
            <!--            <td colspan="3">-->
            <!--            </td>-->
            <!--          </tr>-->
            <!--          <tr>-->
            <!--            <td>Calibration Performed/Remaining</td>-->
            <!--            <td>-->
            <!--              {{ (equipmentStatistics.other.performed * 100 / equipmentStatistics.other.all).toFixed(2) }}%-->
            <!--            </td>-->
            <!--            <td>-->
            <!--              {{ (equipmentStatistics.other.remaining * 100 / equipmentStatistics.other.all).toFixed(2) }}%-->
            <!--            </td>-->
            <!--          </tr>-->
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import moment from 'moment'
import {export_json_to_excel_custom} from "@/vendor/Export2Excel";


export default {
  name: "LaboratoryEquipmentStatistics",

  props: {
    laboratories: {
      type: Array,
      required: true,
    },
    country: {
      type: Object,
      required: true,
    }
  },

  data: () => {
    return {}
  },

  computed: {

    equipmentStatisticsGenerated() {
      return this.generateEquipmentStateStatistic();
    },

    equipmentStatisticsPercent() {
      return this.equipmentStatisticsGenerated.statePercent;
    },

    equipmentStatisticsCalibration() {
      return this.equipmentStatisticsGenerated.stateCalibration;
    }
  },

  methods: {

    generateEquipmentStateStatistic() {

      function addToState(state, data) {
        let percents = [100, 75, 50, 25];

        for (let p of percents) {
          if (data.percent >= p) {
            state[p].push(data);
            break;
          }
        }
      }

      // let statistics = [];
      let statePercent = {
        // percentM_F: {
        '100': [],
        '75': [],
        '50': [],
        '25': [],
        // },

        // percentF_A: {
        //     '100': 0,
        //     '75': 0,
        //     '50': 0,
        //     '25': 0,
        // },
        // other: {
        //     all: 0,
        //     performed: 0,
        //     remaining: 0,
        // }
      };

      let stateCalibration = {
        all: 0,
        performed: 0,
        remaining: 0,
        onTime: 0,
        offTime: 0,
      };

      for (let lab of this.laboratories) {
        if (Array.isArray(lab.equipment)) {
          let equipmentState = {
            lab,
            all: lab.equipment.length,
            functioning: 0,
            validMaintenance: 0,
          };

          for (let eq of lab.equipment) {
            if (eq.condition !== 'Functioning') {
              equipmentState.functioning++;
            }

            if (this.isValidMaintenance(eq)) {
              equipmentState.validMaintenance += 1;
              stateCalibration.performed += 1;


              if (this.isValidMaintenanceOnTime(eq)) {
                stateCalibration.onTime += 1;
              } else {
                stateCalibration.offTime += 1;
              }

            } else {
              stateCalibration.remaining += 1;
            }

            stateCalibration.all += 1;

            // equipmentState.validMaintenance += this.isValidMaintenance(eq) ? 1 : 0
          }

          equipmentState.percent = ((equipmentState.validMaintenance * 100) / equipmentState.functioning).toFixed(2);

          addToState(statePercent, equipmentState);

        }
      }

      return {
        statePercent,
        stateCalibration
      }
    },

    isValidMaintenance(item) {

      let inventoryData = this.country.equipment.find(e =>
          e.category === item.type.category &&
          e.subCategory === item.type.subCategory
      );

      if (inventoryData?.maintenanceCalibration === '0') {
        return true
      }

      if (!Array.isArray(item.maintenanceCalibrationDates)) {
        return false
      }

      let itemLastMaintenance = moment.max(item.maintenanceCalibrationDates.map(e => moment(e)));

      let today = moment();

      let maintenanceTime = moment(itemLastMaintenance).add(inventoryData.maintenanceCalibration, 'weeks');

      let maintenanceDiff = maintenanceTime.diff(today, 'week');

      return !(maintenanceDiff <= 0 || itemLastMaintenance === undefined);

    },

    isValidMaintenanceOnTime(item) {

      let inventoryData = this.country.equipment.find(e =>
          e.category === item.type.category &&
          e.subCategory === item.type.subCategory
      );

      if (inventoryData?.maintenanceCalibration === '0') {
        return true
        //on
      }

      if (!Array.isArray(item.maintenanceCalibrationDates)) {
        return false
        //off
      }

      if (item.maintenanceCalibrationDates.length > 1) {

        item.maintenanceCalibrationDates = item.maintenanceCalibrationDates.sort();

        let itemLastMaintenance = item.maintenanceCalibrationDates[item.maintenanceCalibrationDates.length - 1];
        let itemPreMaintenance = item.maintenanceCalibrationDates[item.maintenanceCalibrationDates.length - 2];

        // let today = moment();

        let maintenanceTime = moment(itemPreMaintenance).add(inventoryData.maintenanceCalibration, 'weeks');

        let maintenanceDiff = maintenanceTime.diff(itemLastMaintenance, 'week');

        return maintenanceDiff >= 0;


      } else {
        return true
        // on
      }

    },


    exportEquipmentStatisticsPercent() {
      let multiData = [];
      {
        const tHeader = [
          '% of equipment in good state', 'Number of labs'
        ];

        const data = Object.entries(this.equipmentStatisticsPercent).map(entries => {
          return [(entries[0] < 100 ? '< ' : '') + entries[0], entries[1].length]
        }).filter(e => e).reverse();

        multiData.push({name: 'Equipment in good state', header: tHeader, data})
      }

      export_json_to_excel_custom({
        multiData,
        filename: 'equipment-state',
        autoWidth: true,
      })

    },

    exportEquipmentStatisticsCalibration() {
      let multiData = [];
      {
        const tHeader = [
          'Calibration', 'Percent'
        ];

        const data = [
            ['Performed', (this.equipmentStatisticsCalibration.performed * 100 / this.equipmentStatisticsCalibration.all).toFixed(2) + ' %'],
            ['Remaining', (this.equipmentStatisticsCalibration.remaining * 100 / this.equipmentStatisticsCalibration.all).toFixed(2) + ' %'],
            ['On-time', (this.equipmentStatisticsCalibration.onTime * 100 / this.equipmentStatisticsCalibration.all).toFixed(2) + ' %'],
            ['Off-time', (this.equipmentStatisticsCalibration.offTime * 100 / this.equipmentStatisticsCalibration.all).toFixed(2) + ' %']
        ]

        multiData.push({name: 'Equipment calibration', header: tHeader, data})
      }

      export_json_to_excel_custom({
        multiData,
        filename: 'equipment-calibration',
        autoWidth: true,
      })

    }
  }

}
</script>

<style scoped>

</style>
